export default __webpack_public_path__ + "static/media/Playstore logo.be9599fe.png";